import {FrmVar} from "../../drawfrm/FrmVar";
import {inches} from "../../const";

// defaults for the profile-dependent cut vars. Shared by the field initializers here
// and applyProfileDefaults (in MdFrameSpec) so a profile switch resets to the same
// values a fresh load would use. (rabbetDepth / tabs are computed per-profile in
// applyProfileDefaults rather than from a constant.)
export const DEFAULT_BOTTOM_RABBET_DEPTH = (1 + 9/16) * inches;
export const DEFAULT_DRYWALL_LIP = 1/2 * inches;
export const DEFAULT_DRYWALL_HOOK_DROP = 1/2 * inches;
export const DEFAULT_KERF_DEPTH = 1/2 * inches;
export const DEFAULT_EXP_FACE = 2.636 * inches;

// The profile-specific cut dimensions that define a frame cross-section's shape —
// everything the FrameProfile* drawings read except the frame-wide jambDepth and
// jambFace (those stay on MdFrameSpec and are passed alongside). Bundled so a frame
// (via MdFrameSpec.doorFrameProfile) — and, later, an individual cell — can carry its
// own profile shape.
export class MdFrameProfileDetail {
    doorThickness = new FrmVar("frameProfile.doorThickness", (1 + 3/4) * inches);
    rabbetDepth = new FrmVar("frameProfile.rabbetDepth", (1 + 5/16) * inches).overrideIsModified(true);
    bottomRabbetDepth = new FrmVar("frameProfile.bottomRabbetDepth", DEFAULT_BOTTOM_RABBET_DEPTH).overrideIsModified(true);
    topTab = new FrmVar("frameProfile.topTab", 1/8 * inches);
    bottomTab = new FrmVar("frameProfile.bottomTab", 1/8 * inches);

    doubleEgressLip = new FrmVar("frameProfile.doubleEgressLip", 2 * inches);
    doubleEgressStep1 = new FrmVar("frameProfile.doubleEgressStep1", 1/2 * inches);
    doubleEgressStep2 = new FrmVar("frameProfile.doubleEgressStep2", 1/2 * inches);
    doubleEgressSmallFace = new FrmVar("frameProfile.doubleEgressSmallFace", 1 * inches);

    drywallLip = new FrmVar("frameProfile.drywallLip", DEFAULT_DRYWALL_LIP);
    drywallHookDrop = new FrmVar("frameProfile.drywallHookDrop", DEFAULT_DRYWALL_HOOK_DROP);

    kerfDepth = new FrmVar("frameProfile.kerfDepth", DEFAULT_KERF_DEPTH).overrideIsModified(true);
    expFace = new FrmVar("frameProfile.expFace", DEFAULT_EXP_FACE);

    // doubleEgressSmallFace is the middle face left after the two egress steps are cut
    // from the jamb face: jambFace - (step1 + step2). jambFace lives on the frame (it's
    // frame-wide, not profile-specific) so it's passed in as a dependency.
    constructor(jambFace: FrmVar) {
        this.doubleEgressSmallFace.createCalculated((props) => {
            return props.jambFace - (props.doubleEgressStep1 + props.doubleEgressStep2);
        }, {
            doubleEgressStep1: this.doubleEgressStep1,
            doubleEgressStep2: this.doubleEgressStep2,
            jambFace,
        }, "jambFace - (doubleEgressStep1 + doubleEgressStep2)");
    }
}
